import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';
import {
    IconColor,
    IconsByType,
    MessageType,
    SnackBarClass,
    SnackBarHorizontalPosition,
    SnackBarVerticalPosition,
} from '../types/snack-bar.types';

const DURATION_MS = 3_000;

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {
    constructor(private snackBar: MatSnackBar) {}

    public displayMessage(
        message: string,
        type: MessageType,
        durationMs = DURATION_MS
    ) {
        return this.snackBar.openFromComponent(SnackBarComponent, {
            duration: durationMs,
            horizontalPosition: SnackBarHorizontalPosition.Right,
            verticalPosition: SnackBarVerticalPosition.Top,
            data: {
                icon: this.getIconByType(type),
                iconColor: this.getIconColorByType(type),
                message,
            },
            panelClass: this.getPanelClassByType(type),
        });
    }

    private getIconByType(type: MessageType) {
        const icons = {
            [MessageType.Error]: IconsByType.Alert,
            [MessageType.Warning]: IconsByType.Alert,
            [MessageType.Notification]: IconsByType.Notification,
            [MessageType.Success]: IconsByType.Success,
        };

        return icons[type];
    }

    private getIconColorByType(type: MessageType) {
        const colors = {
            [MessageType.Warning]: IconColor.Warning,
            [MessageType.Error]: IconColor.Error,
            [MessageType.Notification]: IconColor.Notification,
            [MessageType.Success]: IconColor.Success,
        };

        return colors[type];
    }

    private getPanelClassByType(type: MessageType) {
        const panelClasses = {
            [MessageType.Error]: SnackBarClass.Error,
            [MessageType.Success]: SnackBarClass.Success,
            [MessageType.Notification]: SnackBarClass.Default,
            [MessageType.Warning]: SnackBarClass.Warning,
        };

        return [SnackBarClass.Config, panelClasses[type]];
    }
}
